import { Col, Row } from 'react-bootstrap';
import sucesionImg from 'assets/img/landing/sucesionjpg.jpg'; // Asegúrate de mover tus imágenes a tu carpeta de assets o usar rutas relativas
import accidenteImg from 'assets/img/landing/6365340.webp';

const EliminacionDatosUsuario = () => {
  return (
    <section className="py-10 bg-body-tertiary" id="sucesiones">
      <div className="container-small px-lg-7 px-xxl-3">
        <div className="text-center mb-9">
          <h2 className="fs-3 fs-lg-2">Solicitud de Eliminación de Datos de Usuario</h2>
        </div>

        {/* Sección Sucesiones */}
        <Row className="align-items-center g-5 mb-10">
            <h3 className="fw-bold mb-3">Última actualización: 27/05/2026</h3>
            <p className="text-body-secondary">En cumplimiento con las normativas de privacidad y los requisitos de plataformas de terceros (como Meta/Facebook), Estudio Parkes garantiza su derecho a solicitar la eliminación completa de sus datos personales de nuestros registros.</p>
            <p className="text-body-secondary">Si usted ha interactuado con nuestro sitio web, nuestras redes sociales o se ha comunicado con nosotros y desea que eliminemos su información personal (nombre, teléfono, correo electrónico, historial de consultas), siga estos pasos:</p>
            <p className="text-body-secondary"></p>
<p className="text-body-secondary">Instrucciones para solicitar la eliminación de datos:

Envíe un correo electrónico a nuestra dirección oficial: jap@estudioparkes.com.

En el asunto del correo, escriba: "Solicitud de Eliminación de Datos".

En el cuerpo del correo, por favor incluya el nombre completo y el número de teléfono o correo electrónico con el que nos contactó originalmente, para que podamos identificar sus registros.</p>
<p className="text-body-secondary">Plazo de respuesta:
Procesaremos su solicitud y eliminaremos sus datos de nuestras bases de datos activas en un plazo máximo de 5 días hábiles, enviándole una confirmación una vez que el proceso haya finalizado.</p>
<p className="text-body-secondary">Nota: Es posible que debamos retener cierta información de forma temporal o permanente si existe una obligación legal en curso, un mandato judicial o si usted es un cliente con un caso activo.</p>

            <a href="https://api.whatsapp.com/send/?phone=5491153069479&text&type=phone_number&app_absent=0" className="btn btn-outline-primary rounded-pill mt-3" target="_blank" rel="noreferrer">Contactanos</a>
        </Row>

      </div>
    </section>
  );
};

export default EliminacionDatosUsuario;